module.exports = __webpack_public_path__ + "static/media/sopt8ru.bdcfceb4.pdf";